import {
  Input,
  Modal,
  Form,
  DatePicker,
  message,
  Flex,
  Tooltip,
  Tag,
  Row,
  Col,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  HomeOutlined,
  HistoryOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import moment from "moment";
import api from "@/utils/api";
import dayjs from "dayjs";
import "./index.scss";
import PDFModal from "./component/PDFModal"
import { useLocation } from 'react-router-dom';
import commonFn from "@/utils/commonFn";
import AddModal from "@/views/AccountPayable/UtilityPayment/component/AddModal" ;
import ButtonList from "./component/ButtonList";
import { CustomTable, CustomTableExtend, CustomUploadNew1 } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [selectedList, setSelectedList] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [propTypeList, setPropTypeList] = useState([]);
  const [greater, setGreater] = useState([]);
  const [small, setSmall] = useState([]);

  const initTableHead = {
    amount: null,
    materialRemark: null,
    jobs: null,
    glAcct: null,
    invoiceDateAp: null,
    storeName: null,
    unitAddress: null,
    requestNo: null,
    supervisor: null,
    vendorType: null,
    vendorName: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    // {
    //   title: '#',
    //   dataIndex: '#',
    // },
    {
      title: 'Pay Amount',
      dataIndex: "amount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'amount'),
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={(e) => {
              e.preventDefault();
              setCurrentRecord(record)
              setUploadInvoiceFlag(true)
            }}
            className="CA-AS-AmountStyle"
          >
            <div>{commonFn.amountToDollarFn(text)}</div>
          </span>
        )
      },
    },
    {
      title: 'Invoice #',
      dataIndex: "invoiceNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'invoiceNumber'),
    },
    {
      title: "Status",
      dataIndex: "status",
      titleType: 'Input',
      width: 90,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'status'),
      render: (text, record) => {
        return (
          <a onClick={() => {
            const url = `${window.location.origin}#/JobRequests/Maintenance/Details?id=${record?.maintenanceId}`;
            window.open(url, "_blank", "noopener,noreferrer");
          }}>
            <Tag color="#3c8dbc">{text}</Tag>
          </a>
        );
      },
    },
    {
      title: 'Prop #',
      dataIndex: "propCode",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'propCode'),
    },
    {
      title: "Unit Address, City State",
      dataIndex: "unitAddress",
      // titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "unitAddress"),
    },
    {
      title: 'Material Remark',
      dataIndex: "materialRemark",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      isWrapFlag: 300,
      onChange: e => tableFilterFn(e, 'materialRemark'),
    },
    {
      title: "Job Type",
      dataIndex: "jobs",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "jobType"),
      width: 200,
      render: (text) => (
        <Flex gap="4px 0" wrap>
          {text?.map((item) => (
            <Tooltip title={item}>
              <Tag
                  // color="rgba(109, 140, 81, 0.12)"
                color="blue"
                style={{
                    // color: "#6D8C51",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item}
              </Tag>
            </Tooltip>
          ))}
        </Flex>
      ),
    },
    {
      title: "GL-Title",
      dataIndex: "glAcct",
      // titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Material Pick-Up Date',
      dataIndex: "invoiceDateAp",
      titleType: 'DatePicker',
      isSorter: false,
      onChange: (e) => tableFilterFn(e, 'invoiceDateAp', 'DatePicker'),
    },
    {
      title: 'Hardware Store',
      dataIndex: "storeName",
      // titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'storeName'),
    },
    // {
    //   title: "Request No.",
    //   dataIndex: "requestNo",
    //   titleType: "Input",
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, "requestNo"),
    // },
    {
      title: 'Supervisor',
      dataIndex: "supervisor",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'supervisor')
    },
    {
      title: 'Maintenance Role',
      dataIndex: "vendorType",
      titleType: 'Select',
      width: 90,
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "Maint.Woker", value: "1" },
        { label: "Contractor", value: "2" },
      ],
      render: (text) => {
        const requestStatusMatch = {
          "1": "Maint.Woker",
          "2": "Contractor",
        }
        return requestStatusMatch[text] || ""
      },
      onChange: e => tableFilterFn(e, 'vendorType', 'Select'),
    },
    {
      title: 'Maintenance Name',
      dataIndex: "vendorName",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'vendorName')
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const setGreaterAndSmallFn = async(list = []) => {
    if(!list.length) return
    const ids = list.map(item => item.foreignId).join(",");
    const result = await http.get(api.ApprovalRecent, { params: { ids } });
    setGreater(result?.greater || []); 
    setSmall(result?.small || []); 
  }

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      storeName: new URLSearchParams(location.search).get("storeName"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    };
    const response = await http.get(api.ASmaintenanceMaterialAp, { params });
    // setSelectedList([])
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setGreaterAndSmallFn(list)
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  //复选框
  const rowSelection = {
    selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, 
      disabled: record.approve === "Waiting For Approval" 
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedList(selectedRows);
    },
  };

  const [uploadInvoiceFlag, setUploadInvoiceFlag] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [loading, setLoading] = useState(false);

  const customUploadNewRef = useRef(null);

  const materialShowInvoiceFn = async() => {
    const { maintenanceMaterialInvoiceId } = currentRecord
    setLoading(true)
    const response = await http.get(api.MaterialShowInvoice, {params: { maintenanceMaterialInvoiceId }});
    if (response.code === "1") {
      form.setFieldsValue({
        invoiceAmount: response.data?.invoiceAmount,
        invoiceNumber: response.data?.invoiceNumber,
        invoiceDate: dayjs(response.data?.invoiceDate) || '',
        filePaths: response.data?.fileList?.map(item => item.relativePath)
      })
      customUploadNewRef.current.initUpdateList(response.data?.fileList?.map(item => ({...item, allPath: item.url, name: item?.name || item?.fileName})));
    } else {
      message.error(response.msg || "Failed to fetch user data");
    }
    setLoading(false)
  }

  useEffect(() => {
    if(uploadInvoiceFlag){
      materialShowInvoiceFn()
    }
  }, [uploadInvoiceFlag])

  const getDictionaryFn = async() => {
    const response = await http.get(api.getDictionary, { params: {
        type:'util_payment',
        value: 'propType'
    }});
    setPropTypeList(response)
  }

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  }
    
  useEffect(() => {
    getDictionaryFn()
  }, [])

  useEffect(() => {
    if(propTypeList?.length){
      setColumns(initColumns);
    }
  }, [propTypeList]);


  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  const [addopen, setAddOpen] = useState(false);
  const [addRecord, setAddRecord] = useState(null);
  const [form] = Form.useForm();
  const [formTenant] = Form.useForm();

  const downLoadFn = async () => {
    const params = {
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      storeName: new URLSearchParams(location.search).get("storeName"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    }
    const blob = await http.get(api.exportMaintenanceMaterialApCsv, {params, responseType: 'blob'});
    return {
      blob,
      name: `Maintenance_material_ap`,
    };
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
        downLoadFn={() => downLoadFn()}
      >
        <ButtonList
          email={new URLSearchParams(location.search).get("email")}
          transactionsType={new URLSearchParams(location.search).get("type")}
          moduleType={new URLSearchParams(location.search).get("module")}
          selectedList={selectedList}
          refreshTableFn={() => setRefreshKey(+new Date())}
        />
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          ...rowSelection,
        }}
        rowClassName={(record) => {
          if(greater.includes(record.vendorPaymentId)){
            return ["greater-row"]
          }
          if(small.includes(record.vendorPaymentId)){
            return "small-row"
          }
          return [record.vendorPaymentId]
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        tableCss="AS-tableClass"
      />

      <AddModal 
        addopen={addopen}
        form={form}
        formTenant={formTenant}
        handleModalSubmitlFn={() => {setAddOpen(false); getTableListFn(pagination.current, pagination.pageSize, tableHead)}}
        handleModalCancelFn={() => setAddOpen(false)}
        record={addRecord}
      />

      <Modal
        title="View Invoice"
        width="80%"
        maskClosable={false}
        open={uploadInvoiceFlag}
        onCancel={() => (setUploadInvoiceFlag(false))}
        footer={false}
      >
        <Form
          form={form}
          layout="horizontal"
          labelCol={{span: 8}}
          wrapperCol={{span: 16}}
        >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Form.Item
              name="invoiceDate"
              label="Invoice Date"
              rules={[{ required: true, message: "Invoice Date is required!" }]}
            >
              <DatePicker
                disabled
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
                getPopupContainer={(trigger) => trigger.parentElement}
              />
            </Form.Item>

            {commonFn.formInputNumberDoc({
              name: 'invoiceAmount', 
              label: 'Invoice Amount',
              form,
              disabled: true,
              // isNoRequired: true,
              validator: (_, value, callback) => {
                if(value >= 1000000){
                  callback('The Amount Must Be Between 0 And 1000000.')
                } else {
                  callback()
                }
              }
            })}

            <Form.Item
              name="invoiceNumber"
              label="Invoice #"
              rules={[{ required: true, message: 'Invoice # is required!' }]}
            >
              <Input
                disabled
                placeholder="Please input Invoice #"
              />
            </Form.Item>
          </Col>
          <Col span={16}>
          <div
            style={{
              marginBottom: "16px",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            <HomeOutlined style={{ marginRight: "8px" }} />
            Files
          </div>
          <Form.Item
            name="filePaths" 
            label="Files"
            labelCol={{ span: 0 }} 
            wrapperCol={{ span: 24 }}
            rules={[{ required: true, message: "Files is required!" }]}
          >
            <CustomUploadNew1
              ref={(el) => (customUploadNewRef.current = el)}
              customConfig={{
                pdfHeight: "76vh",
                notMultiple: true,
                accept: ".jpg, .jpeg, .png, .pdf",
                status: 'add',
                disabled: true,
                noUploadBtn: true
              }}
              setFilePaths={setFilePaths} 
              filePaths={filePaths} 
              setBtnDisabled={setBtnDisabled}
              btnDisabled={btnDisabled}
            />
          </Form.Item>
          </Col>
        </Row>
        </Form>
      </Modal>
    </div>
  );
});
export default MainTable;